module.exports = __webpack_public_path__ + "img/verify.156d7274.svg";